<template>
  <div class="specialDeal-screen">
     <b-tabs class="tabs-payment">
       
        <b-tab @click="infiniteHandler($refs.infiniteLoading)" class="tab">
          <template v-slot:title>
							<span>{{
								 $t("specialDeal.fristTab")
							}}</span>
						</template>
            <div class="search-input d-flex flex-row justify-content-between">
              <b-form-input
                class="input-search"
                :placeholder="$t('userDashboard.messages.search')"
                v-model="config.search"
              ></b-form-input>
              <MagnifyIcon class="icon-search" />
              <b-dropdown class="menu-dropdown" no-flip>
                <template v-slot:button-content>
                  <span>
                    {{
                      config.order_by?
                        config.order_by=='NewFirst'
                        ? $t('specialDeal.oldToNew') : $t('specialDeal.newToOld') 
                        : $t('specialDeal.sortBy')
                    }}
                    <ChevronDownIcon />
                  </span>
                </template>
                <b-dropdown-item @click="config.order_by='NewFirst'" value="NewFirst"
                  >{{$t('specialDeal.oldToNew')}}</b-dropdown-item
                >
                <b-dropdown-item @click="config.order_by='OldFirst'" value="OldFirst"
                  >{{$t('specialDeal.newToOld')}}</b-dropdown-item
                >
              </b-dropdown>
              <b-button class="ml-2 success-button" v-b-modal.popup @click="resetspecialDeal">
                 <IconPlus /> {{$t('specialDeal.addNew')}}
                </b-button>
            </div>
            <div class="content-body-div mt-3" :class="{ 'no-data': !specialDealList.length }">
              <b-col no-gutters>
                <template v-for="(item, index) in specialDealList" >
                  <b-col col :key="index" class="p-0 mb-3">
                    <div class="template-item ">
                      <b-col class="justify-content-betweenp-0" :class="{'upcoming':item.upcoming}">
                        <div class="button-div d-flex flex-row align-items-center align-self-center justify-content-between p-1" >
                            <div>
                              <h5 >{{item.name}}</h5>
                            </div>
                            <div class="text-right">
                              
                              <b-form-checkbox @change="toggleHotDealsActive(item.id)" v-model="item.is_active" name="check-button" switch >
                                {{ item.is_active?'Enabled':'Disabled' }}
                              </b-form-checkbox>
                              <b-button @click="resetspecialDeal();edit(item)"><IconPencil style="color:var(--projectPrimaryColor); width: 16px;"/></b-button>
                              <b-button @click="deletespecialDeal(item)"><IconTrash style="width: 16px;"/></b-button>
                              
                              <span class="status"  v-if="item.upcoming">{{$t('specialDeal.upcoming')}}</span>
                              <span class="status"  v-if="item.start_date <=   moment(new Date()).format('YYYY-MM-DD') && 
                              item.expire_date >=   moment(new Date()).format('YYYY-MM-DD')">{{$t('specialDeal.active')}}</span>
                            </div>
                        </div>
                        <div class="d-flex flex-row justify-content-between p-1">
                          <div>{{$t('specialDeal.numberOfPackageMaxUse')}} {{item.required_discount_code.max_usages}}</div>
                          <div>{{$t('specialDeal.numberOfUsePerUser')}} {{item.required_discount_code.max_usages_per_user}}</div>
                          <div style="color:var(--projectPrimaryColor);font-weight:bold">{{item.required_discount_code.code}}</div>
                        </div>
                        <div class="d-flex flex-row justify-content-between p-1">
                          <div>{{$t('specialDeal.expiryDate')}} {{item.start_date}} - {{item.expire_date}}</div>
                          <div id="copy" style="color:var(--projectPrimaryColor);cursor: pointer;" @click="copyFunction(item)">{{$t('specialDeal.copy')}}</div>
                          <!-- showCopySuccess{{showCopySuccess}} -->
                          <div class="d-flex flex-row align-items-center align-self-center justify-content-center"
                           style="width: 99px;height: 40px;background: #E8FFE5 0% 0% no-repeat padding-box;border-radius: 4px;position: absolute;right: 80px;bottom: 3px;"
                            v-if="showCopySuccess==item.id"
                          >
                          {{$t('copied')}}
                          </div>
                        </div>
                      </b-col>
                    </div>
                  </b-col>
                </template>
              </b-col>
              
            </div>
            <infinite-loading
                @infinite="infiniteHandler"
                ref="infiniteLoading"
                spinner="spiral"
                throttleLimit="50"
                :distance="1"
              >
                <span slot="no-results"
                  ><b-alert show variant="light" v-if="!specialDealList.length">{{
                    $t("adminDashboard.list.dataEmpty")
                  }}</b-alert></span
                >
                <span slot="no-more"></span>
              </infinite-loading>
        </b-tab>
        <b-tab @click="infiniteHandlerExpired($refs.infiniteLoadingApproveOrReject)"  class="tab">
						<template v-slot:title>
							<span>{{
								 $t("specialDeal.secondTab")
							}}</span>
						</template>
            <div class="search-input d-flex flex-row justify-content-between">
              <b-form-input
                class="input-search"
                :placeholder="$t('userDashboard.messages.search')"
                v-model="configApproveOrRejected.search"
              ></b-form-input>
              <MagnifyIcon class="icon-search" />
              <b-dropdown class="menu-dropdown" no-flip>
                <template v-slot:button-content>
                  <span>
                    {{
                      configApproveOrRejected.order_by?
                        configApproveOrRejected.order_by=='NewFirst'
                        ?$t('specialDeal.oldToNew') : $t('specialDeal.newToOld') 
                        : $t('specialDeal.sortBy')
                    }}
                    <ChevronDownIcon />
                  </span>
                </template>
                <b-dropdown-item @click="configApproveOrRejected.order_by='NewFirst'" value="NewFirst"
                  >{{$t('specialDeal.oldToNew')}}</b-dropdown-item
                >
                <b-dropdown-item @click="configApproveOrRejected.order_by='OldFirst'" value="OldFirst"
                  >{{$t('specialDeal.newToOld')}} </b-dropdown-item
                >
              </b-dropdown>
            </div>
            <div class="content-body-div" :class="{ 'no-data': !specialDealApproveOrRejected.length }">
              <b-col no-gutters>
                <template v-for="(item, index) in specialDealApproveOrRejected">
                  <b-col col :key="index" class="p-0 mb-3">
                    <div class="template-item ">
                      <b-col class="justify-content-between">
                        <div class="button-div d-flex flex-row align-items-center align-self-center justify-content-between p-1" >
                            <div>
                              <h5 style="color: #ADADAD!important;">{{item.name}}</h5>
                            </div>
                            <div>
                              <span class="status" style="background-color:#ADADAD!important">{{'Expired'}}</span>
                            </div>
                        </div>
                        <div class="d-flex flex-row justify-content-between p-1">
                          <div>{{$t('specialDeal.numberOfPackageMaxUse')}} {{item.required_discount_code.max_usages}}</div>
                          <div>{{$t('specialDeal.numberOfUsePerUser')}} {{item.required_discount_code.max_usages_per_user}}</div>
                          <div style="color:#444444;font-weight:bold">{{item.required_discount_code.code}}</div>
                        </div>
                        <div class="d-flex flex-row justify-content-between p-2">
                          <div>{{$t('specialDeal.expiryDate')}} {{item.start_date}} - {{item.expire_date}}</div>
                        </div>
                      </b-col>
                    </div>
                  </b-col>
                </template>
              </b-col>
              <infinite-loading
                @infinite="infiniteHandlerExpired"
                ref="infiniteLoadingApproveOrReject"
                spinner="spiral"
                throttleLimit="50"
                :distance="1"
              >
                <span slot="no-results"
                  ><b-alert show variant="light" v-if="!specialDealApproveOrRejected.length">{{
                    $t("adminDashboard.list.dataEmpty")
                  }}</b-alert></span
                >
                <span slot="no-more"></span>
              </infinite-loading>
            </div>
       </b-tab>
        
     </b-tabs>
    <b-modal
      id="popup"
      modal-class="modal-specialDeal-template"
      size="xl"
      centered
      hide-header
      hide-footer
      scrollable 
    >
      <div>
        <div class="modal-header">
          <h5>{{$t('specialDeal.addspecialDeal')}}</h5>
          <b-form-checkbox v-model="specialDeal.is_active" name="check-button" switch>
            {{ specialDeal.is_active?'Enabled':'Disabled' }}
          </b-form-checkbox>
        </div>
        <div class="trasnlation-div d-flex flex-row justify-content-start align-items-start" v-if="false">
            <template v-for="(item, key) in supportedLanguages">
              <div :key="key" class="lang-div d-flex flex-row justify-content-center align-items-center p-2" :class="selectedLangugae==item?'active-lang':''"
                @click="changeLanguageTab(item)">
                <span v-if="selectedLangugae==item" >
                    {{$t('addListing.details.selectLanguage'+item)}}
                </span>
                <span v-else>
                    {{$t('addListing.details.selectLanguage'+item)}}
                </span>
                
              </div>
            </template>
            
          </div>
        <div class="modal-body form-group">
          
          <div class="input-div col" id="input-group-search">
            <div class="d-flex flex-column justify-content-start m-3">
              <label>{{$t('specialDeal.name')}}</label>
              <b-form-input
                :class="{
                  'input-error': validateErrors ? validateErrors.name : false,
                }"
                class="input-search"
                ref="searchInput"
                :placeholder="$t('specialDeal.name')"
                v-model="specialDeal.name"
              ></b-form-input>
            </div>

            <div class="d-flex flex-column justify-content-start m-3">
              <label>{{$t('specialDeal.homeDescription')}}</label>
              <b-form-input
                :class="{
                  'input-error': validateErrors
                    ? validateErrors.home_description
                    : false,
                }"
                class="input-search"
                ref="searchInput"
                :placeholder="$t('specialDeal.homeDescription')"
                v-model="specialDeal.home_description"
              ></b-form-input>
            </div>
            <div class="d-flex flex-column justify-content-start m-3">
              <label>{{$t('specialDeal.packageDescription')}}</label>
              <b-form-input
                :class="{
                  'input-error': validateErrors
                    ? validateErrors.package_description
                    : false,
                }"
                class="input-search"
                ref="searchInput"
                :placeholder="$t('specialDeal.packageDescription')"
                v-model="specialDeal.package_description"
              ></b-form-input>
            </div>
            <div class="d-flex flex-column justify-content-start m-3">
              <label>{{$t('specialDeal.discountCode')}}</label>
              <b-form-input
               :class="{
                  'input-error': validateErrors
                    ? validateErrors.discountCode
                    : false,
                }"
                class="input-search"
                ref="searchInput"
                :placeholder="$t('specialDeal.discountCode')"
                v-model="specialDeal.discountCode"
              ></b-form-input>
            </div>
            <b-row class="m-3 justify-content-between">
              <div class="d-flex flex-column justify-content-start" style="width: 49%;">
                <label>{{$t('specialDeal.numberOfUseDiscountCode')}}</label>
                <masked-input
                    type="text"
                    class="input-search form-control"
                    v-model="specialDeal.numberOfUseDiscountCode"
                    :class="{
                    'input-error': validateErrors
                      ? validateErrors.numberOfUseDiscountCode
                      : false,
                    }"
                    :mask="numberAmountMask()"
                    :placeholder="$t('specialDeal.numberOfUseDiscountCode')"
                  ></masked-input>
                
              </div>
              <div class="d-flex flex-column justify-content-start" style="width: 49%;">
                <label>{{$t('specialDeal.numberOfTimeUserCanUse')}}</label>
                <masked-input
                    type="text"
                    class="input-search form-control"
                    v-model="specialDeal.numberOfTimeUserCanUse"
                    :class="{
                    'input-error': validateErrors
                      ? validateErrors.numberOfTimeUserCanUse
                      : false,
                    }"
                    :mask="numberAmountMask()"
                    :placeholder="$t('specialDeal.numberOfTimeUserCanUse')"
                  ></masked-input>
              </div>
            </b-row>
            <div
              class="d-flex flex-column justify-content-start m-3"
            >
              <label  :class="{
                'input-error': validateErrors ? validateErrors.startingAndEndDate : false,
              }">{{$t('specialDeal.startingAndEndDate')}}</label>
              <b-row class="ml-1 mr-3 justify-content-between align-self-center align-items-center w-100">
                  <datepicker
                      class="date-input"
                      :language="th"
                      v-model="specialDeal.startingDate"
                      :disabledDates="disabledDates"
                      
                      style="width: 45%;max-width:100%"
                    ></datepicker>
                  <div class="text">{{ $t('specialDeal.to') }}</div>
                    <datepicker
                      class="date-input"
                      :language="th"
                      v-model="specialDeal.endDate"
                      :disabledDates="disabledDates"
                      
                      style="width: 45%;max-width:100%"
                    ></datepicker>
              </b-row>
            </div>
            <div
              class="d-flex flex-row justify-content-center align-self-center m-3"
            >
              <b-button class="cancel-button ml-3 w-25" @click="hidePopup();" style="border:none!important;"
                >{{$t('specialDeal.cancel')}}</b-button
              >
              <b-button class="success-button ml-3  w-25" @click="addspecialDeal()"
                >{{specialDeal.id?$t('specialDeal.update'):$t('specialDeal.add')}}</b-button
              >
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import $ from "jquery";
import moment from "moment";
import Loading from "@/components/ui/loading";
import InfiniteLoading from "vue-infinite-loading";
import MagnifyIcon from "vue-material-design-icons/Magnify.vue";
import IconPlus from "@/components/icons/IconPlus";
import IconTrash from "@/components/icons/IconTrash";
import IconPencil from "@/components/icons/IconPencil";
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';
import { en, th } from 'vuejs-datepicker/dist/locale';
import Datepicker from 'vuejs-datepicker';
import _ from 'lodash';
import { Trans } from '@/plugins/Translation';
import MaskedInput from 'vue-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
export default {
  components: {
    InfiniteLoading,
    MagnifyIcon,
    IconPlus,
    IconTrash,
    IconPencil,
    ChevronDownIcon,
    Datepicker,
    MaskedInput
  },
  data() {
    return {
      supportedLanguages:[],
			selectedLangugae:null,
      showCopySuccess:false,
      moment:moment,
      filterSelected:0,
      config: {
        itemCount: 10,
        take: 10,
        page: 1,
        pageCount: 1,
        order_by: 'OldFirst',
        filter_by : 'Current',
        search:null,
      },
      configApproveOrRejected: {
        itemCount: 10,
        take: 10,
        page: 1,
        pageCount: 1,
        search: null,
        order_by: 'NewFirst',
        filter_by : 'Expired',
      },
      specialDealList: [],
      specialDealApproveOrRejected: [],
      specialDeal: {
        is_active:true,
        name: null,
        home_description : null,
        package_description : null,
        discountCode: null,
        numberOfUseDiscountCode:null,
        numberOfTimeUserCanUse:null,
        language:'th',
        startingDate: new Date(),
        endDate: new Date(new Date().setDate(new Date().getDate() + 1)),
        site: 0
      },
      specialPackageInOtherLang:{},
      en:en,
      th:th,
      disabledDates: {
				to: new Date(new Date().setDate(new Date().getDate() - 1)), // Disable all dates up to specific date
				from: new Date(new Date().setFullYear(new Date().getFullYear() + 1))  // Disable all dates after specific date
			},
      validateErrors: {},
      countError: 0,
      rejectedMessage:null,
      selectedspecialDeal:null
    };
  },
  created() {
    this.supportedLanguages=Trans.supportedLanguages;
    // Trans.supportedLanguages.forEach((elm,index)=>{
		// 	if(elm==Trans.currentLanguage){
		// 		this.supportedLanguages=this.moveArrayItemToNewIndex(Trans.supportedLanguages,index,0);
		// 	}
		// })
  },
  computed: {},
  mounted() {
  },
  watch: {
      showCopySuccess(val){
        if(val){
          setTimeout(()=>{
            this.showCopySuccess=false;
          },1000)
        }
      },
      'config.search'(val){
        if(val){
          this.searchspecialDeal();
        }
      },
      'config.order_by'(val){
        this.searchspecialDeal();
      },
      'configApproveOrRejected.search'(val){
        if(val){
          this.searchForApproveRejecte();
        }
      },
      'configApproveOrRejected.order_by'(val){
        if(val){
          this.searchForApproveRejecte();
        }
      },
      
  },
  methods: {
    ...mapActions("AdminHotdealsController", ["ADD_HOT_DEALS", "GET_LIST_OF_HOT_DEALS", "UPDATE_HOT_DEALS", "DELTE_HOT_DEALS", "TOGGLE_HOTDEALS_ACTIVE"]),
    numberAmountMask() {
			return createNumberMask({
				prefix: '',
				suffix: '',
				allowDecimal: true,
				includeThousandsSeparator: true,
				allowNegative: false
			});
		},
    moveArrayItemToNewIndex(arr, old_index, new_index) {
			if (new_index >= arr.length) {
				var k = new_index - arr.length + 1;
				while (k--) {
					arr.push(undefined);
				}
			}
			arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
			return arr; 
		},
    async searchspecialDeal(){
     let upcoming=false;
     let obj={
        take: this.config.take,
        page: this.config.page,
        order_by:this.config.order_by,
        filter_by:this.config.filter_by
      }
      if(this.config.search){
        obj.search=this.config.search;
      }
      let response = await this.GET_LIST_OF_HOT_DEALS(obj);
      if (response) {
        response.data.data.forEach((elm)=>{
          if(elm.start_date >  moment(new Date()).format('YYYY-MM-DD')&&!upcoming){
            elm.upcoming=true;
            upcoming=true;
          }
        })
        this.config.itemCount = response.data.meta.itemCount;
        this.config.take = response.data.meta.take;
        this.config.page = response.data.meta.page;
        this.config.pageCount = response.data.meta.pageCount;
        this.specialDealList = response.data.data;
      }
    },
    async infiniteHandler($state) {
      let upcoming=false;
      let obj={
        take: this.config.take,
        page: this.config.page,
        order_by:this.config.order_by,
        filter_by:this.config.filter_by
      }
      if(this.config.search){
        obj.search=this.config.search;
      }
      let response = await this.GET_LIST_OF_HOT_DEALS(obj);
      if (response) {
        if (!response.data.data) {
          return $state._uid?$state.stateChanger.complete():$state.complete();
        }
        this.config.itemCount = response.data.meta.itemCount;
        this.config.take = response.data.meta.take;
        this.config.page = response.data.meta.page;
        this.config.pageCount = response.data.meta.pageCount;
        response.data.data.forEach((elm)=>{
          if(elm.start_date >  moment(new Date()).format('YYYY-MM-DD')&&!upcoming){
            elm.upcoming=true;
            upcoming=true;
          }
        })
        if (this.config.page == 1) {
          this.specialDealList = response.data.data;
        } else {
          response.data.data.forEach((elm) => {
            this.specialDealList.push(elm);
          });
        }
        if (this.config.page < this.config.pageCount) {
          this.config.page += 1;
          $state._uid?$state.stateChanger.loaded():$state.loaded();
        } else{
           $state._uid?$state.stateChanger.complete():$state.complete();
        };
      }
    },
    
    
    resetspecialDeal(){
      this.specialDeal= {
        name: null,
        is_active:true,
        home_description: null,
        package_description: null,
        discountCode: null,
        numberOfUseDiscountCode:null,
        numberOfTimeUserCanUse:null,
        startingDate: new Date(),
        endDate: new Date(new Date().setDate(new Date().getDate() + 1)) ,
        site: 0
      }
    },
    showPopup() {
      // console.log("show popup")
      this.$bvModal.show("popup");
    },
    hidePopup() {
      this.$bvModal.hide("popup");
    },
    checkForm(e) {
      this.countError = 0;
      this.validateErrors = {};
      this.isValidate = true;
      if (this.specialDeal.name && this.specialDeal.name.match(/[\u1000-\uFFFF]+/g)) {
        this.validateErrors[`name`] = true;
        this.countError++;
        this.makeToastError(this.$t("Marks or special characters are not allowed"));
        return;
      }
      if (!this.specialDeal.name) {
        this.validateErrors[`name`] = true;
        this.countError++;
      }
      if (!this.specialDeal.home_description) {
        this.validateErrors[`home_description`] = true;
        this.countError++;
      }
      if (!this.specialDeal.package_description) {
        this.validateErrors[`package_description`] = true;
        this.countError++;
      }
      if (!this.specialDeal.discountCode) {
        this.validateErrors[`discountCode`] = true;
        this.countError++;
      }
      if (!this.specialDeal.numberOfUseDiscountCode) {
        this.validateErrors[`numberOfUseDiscountCode`] = true;
        this.countError++;
      }
      if (!this.specialDeal.numberOfTimeUserCanUse) {
        this.validateErrors[`numberOfTimeUserCanUse`] = true;
        this.countError++;
      }
      if (!this.specialDeal.startingDate&&!this.specialDeal.endDate) {
        this.validateErrors[`startingAndEndDate`] = true;
        this.countError++;
      }
      console.log("this.validateErrors", this.validateErrors);
      
    },
    addspecialDeal() {
      this.$root.loading=true;
      this.checkForm();
      if (!this.countError) {
        let a = [];
        console.log("this.specialPackageInOtherLang",_.size(this.specialPackageInOtherLang))
        console.log("this.specialPackageInOtherLang",this.specialPackageInOtherLang)
        if(_.size(this.specialPackageInOtherLang)){
          for (var key in this.specialPackageInOtherLang) {
              if (this.specialPackageInOtherLang.hasOwnProperty(key)) {
                  a.push(this.specialPackageInOtherLang[key]);
              }
          }
        }else{
          a.push({
            home_description:this.specialDeal.home_description,
            package_description:this.specialDeal.package_description,
            name:this.specialDeal.name,
            language:Trans.currentLanguage
          })
        }
        let obj={
            "discount_code": this.specialDeal.discountCode,
            "start_date": this.specialDeal.startingDate,
            "expire_date": this.specialDeal.endDate,
            "max_usages": this.specialDeal.numberOfUseDiscountCode,
            "max_usages_per_user": this.specialDeal.numberOfTimeUserCanUse,
            "hot_deal_locales":a,
            "is_active":this.specialDeal.is_active,
            site: 0
          }
        if(!this.specialDeal.id){
          
          this.ADD_HOT_DEALS(obj).then((data) => {
            this.hidePopup();
            this.searchspecialDeal();
            this.$root.loading=false;
            this.resetspecialDeal();
            console.log("data", data);
          }).catch((err)=>{
            console.log("err",err)
            this.$root.loading=false;
              this.showToast(this.$t('specialDeal.'+err.data.detail),"danger");
          });
        }else{
          this.UPDATE_HOT_DEALS({id:this.specialDeal.id,body:obj}).then((data) => {
            this.hidePopup();
            this.searchspecialDeal();
            this.$root.loading=false;
            this.resetspecialDeal();
            console.log("data", data);
          }).catch((err)=>{
            this.$root.loading=false;
              this.showToast(this.$t('specialDeal.'+err.data.detail),"danger");
          });
        }
      } else {
        this.$root.loading=false;
        this.showToast("Check the form!","danger");
      }
    },
    showToast(text,type){
        this.$bvToast.toast(text, {
          title: text,
          variant: type,
          solid: true,
        });
    },
    edit(item){
      console.log("item",item)
      this.specialDeal={
        discountCode: item.required_discount_code.code,
        numberOfUseDiscountCode:item.required_discount_code.max_usages.toLocaleString("th-TH") ,
        numberOfTimeUserCanUse:item.required_discount_code.max_usages_per_user.toLocaleString("th-TH") ,
        startingDate: item.start_date,
			  endDate: item.expire_date,
        id: item.id,
        is_active:item.is_active,
        site: 0
      }
      item.package_detail_locales.forEach(el=>{
        if(el.language==Trans.currentLanguage){
          this.specialDeal.home_description=el.home_description;
          this.specialDeal.package_description=el.package_description;
          this.specialDeal.name=el.name;
        }
      })
      this.showPopup();
    },
    deletespecialDeal(item){
      let _this=this;
      this.$swal({
				title: this.$i18n.t('userDashboard.userManage.modalDelete.title'),
				text: item.name,
				customClass: {
					container: 'swal-del-item'
				},
				showCancelButton: true,
				cancelButtonColor: 'var(--projectPrimaryColor) !important',
				confirmButtonColor: '#DC3849',
				cancelButtonText: this.$i18n.t(
					'userDashboard.userManage.modal.btnConfirm'
				),
				confirmButtonText: this.$i18n.t(
					'userDashboard.userManage.modal.btnCancel'
				),
				preConfirm: () => {
					 _this.DELTE_HOT_DEALS(item).then((data)=>{
                _this.showToast(item.name+" deleted!","success");
                _this.searchspecialDeal();
            }).catch((err)=>{
              console.log("err",err)
                _this.showToast(err.data.detail=='LISTINGS_FOUND'?this.$t('specialDeal.deletedError'):_this.$t('specialDeal.createdError'),"danger");
            });
				}
			});
       
    },
    async searchForApproveRejecte(){
      let obj={
        take: this.configApproveOrRejected.take,
        page: this.configApproveOrRejected.page,
        order_by:this.configApproveOrRejected.order_by,
        filter_by:this.configApproveOrRejected.filter_by
      }
       if(this.configApproveOrRejected.search){
        obj.search=this.configApproveOrRejected.search;
      }
      let response = await this.GET_LIST_OF_HOT_DEALS(obj);
      this.configApproveOrRejected.itemCount = response.data.meta.itemCount;
      this.configApproveOrRejected.take = response.data.meta.take;
      this.configApproveOrRejected.page = response.data.meta.page;
      this.configApproveOrRejected.pageCount = response.data.meta.pageCount;
      this.specialDealApproveOrRejected = response.data.data;
    },
    async infiniteHandlerExpired($state) {
      let obj={
        take: this.configApproveOrRejected.take,
        page: this.configApproveOrRejected.page,
        order_by:this.configApproveOrRejected.order_by,
        filter_by:this.configApproveOrRejected.filter_by
      }
      if(this.configApproveOrRejected.search){
        obj.search=this.configApproveOrRejected.search;
      }
      let response = await this.GET_LIST_OF_HOT_DEALS(obj);
      if (response) {
        if (!response.data.data) {
          return $state._uid?$state.stateChanger.complete():$state.complete();
        }
        this.configApproveOrRejected.itemCount = response.data.meta.itemCount;
        this.configApproveOrRejected.take = response.data.meta.take;
        this.configApproveOrRejected.page = response.data.meta.page;
        this.configApproveOrRejected.pageCount = response.data.meta.pageCount;
        if (this.configApproveOrRejected.page == 1) {
          this.specialDealApproveOrRejected = response.data.data;
        } else {
          response.data.data.forEach((elm) => {
            this.specialDealApproveOrRejected.push(elm);
          });
        }
        if (this.configApproveOrRejected.page < this.configApproveOrRejected.pageCount) {
          this.configApproveOrRejected.page += 1;
          $state._uid?$state.stateChanger.loaded():$state.loaded();
        } else $state._uid?$state.stateChanger.complete():$state.complete();
      }
    },
    copyFunction(item){
      let _this=this;
      console.log("copy function");
      var copyText = item.required_discount_code.code;
      navigator.clipboard.writeText(copyText).then(function() {
        console.log('Async: Copying to clipboard was successful!');
        _this.showCopySuccess=item.id;
      }, function(err) {
        console.error('Async: Could not copy text: ', err);
      });

    },
    changeLanguageTab(lang){
      console.log("lang",lang)
      console.log("this.specialPackageInOtherLang",this.specialPackageInOtherLang)
      console.log("this.specialDeal",this.specialDeal)
			lang==Trans.currentLanguage?false:this.checkForm();
			if(lang==Trans.currentLanguage?true:!this.countError){
				if(lang!=this.selectedLangugae){
					if(Object.keys(this.specialPackageInOtherLang).length){
            console.log("this.specialPackageInOtherLang[lang]!=undefined",typeof this.specialPackageInOtherLang[lang])
						if(this.specialPackageInOtherLang[lang]!=undefined){
              console.log("if undefined")
							this.specialDeal.home_description=this.specialPackageInOtherLang[lang].home_description;
							this.specialDeal.package_description=this.specialPackageInOtherLang[lang].package_description;
							this.specialDeal.name=this.specialPackageInOtherLang[lang].name;
							this.specialDeal.language=this.specialPackageInOtherLang[lang].language;
							this.$forceUpdate();
						}else{
              console.log("else")
							this.specialPackageInOtherLang[Trans.currentLanguage]={
								home_description:_.clone(this.specialDeal.home_description),
								package_description:_.clone(this.specialDeal.package_description),
								name:_.clone(this.specialDeal.name),
								language:_.clone(lang)
							}
							this.specialDeal.home_description=null;
							this.specialDeal.package_description=null;
							this.specialDeal.name=null;
							this.specialDeal.language=null;
							this.$forceUpdate();
						}
					}else{
            console.log("1st else")
						this.specialPackageInOtherLang[Trans.currentLanguage]={
							home_description:_.clone(this.specialDeal.home_description),
							package_description:_.clone(this.specialDeal.package_description),
							name:_.clone(this.specialDeal.name),
							language:_.clone(Trans.currentLanguage)
						}
						this.specialDeal.home_description=null;
						this.specialDeal.package_description=null;
						this.specialDeal.name=null;
						this.specialDeal.language=null;
					}
					this.selectedLangugae=lang;
					this.$forceUpdate();
				}
			}else{
				this.$bvModal.show('trasnlatation-error');
			}
    },
    
    toggleHotDealsActive(id){
      this.TOGGLE_HOTDEALS_ACTIVE({id:id}).then((data)=>{
        this.searchspecialDeal();
      })
    }
  },
};
</script>
<style lang="scss">
@import "adminManageSpecialDeals.scss";
</style>
